module.exports = new __parcel__URL__("whale.cc048b8e.svg").toString();